/// 担当者マスタ API クライアント (`/api/admin/accounts`)。ADR 20260528 / PR-ACC-1。

import type {
  Account,
  AssignableAccount,
  AccountSummary,
  AccountSync,
  InviteAccountRequest,
} from '@shared/types/account';
import { api } from './client';

const adminBase = '/api/admin/accounts';
const assignableBase = '/api/accounts/assignable';

/// 一覧 + ドロップダウン候補 (current_role / primary_email 付き)。
export function listAccounts(): Promise<Account[]> {
  return api.get<Account[]>(adminBase);
}

/// 顧客DBの担当者候補。メール / ロールは含めず、member / readonly でも読める。
export function listAssignableAccounts(): Promise<AssignableAccount[]> {
  return api.get<AssignableAccount[]>(assignableBase);
}

/// 担当者を招待する (DB の invited 行作成 + Auth0 invitation 発行)。
export function inviteAccount(body: InviteAccountRequest): Promise<AccountSummary> {
  return api.post<AccountSummary>(`${adminBase}/invitations`, body);
}

export function deactivateAccount(id: string): Promise<AccountSummary> {
  return api.post<AccountSummary>(`${adminBase}/${encodeURIComponent(id)}/deactivate`, {});
}

export function reactivateAccount(id: string): Promise<AccountSummary> {
  return api.post<AccountSummary>(`${adminBase}/${encodeURIComponent(id)}/reactivate`, {});
}

/// 認証情報を削除する (失効、issue #420)。Auth0 user を削除してログインを恒久抹消し、
/// DB の identity を消して inactive にする。app_accounts (CRM 記録) と履歴は残る。
/// 不可逆。super_admin 専用。
export function revokeCredentials(id: string): Promise<void> {
  return api.post<void>(`${adminBase}/${encodeURIComponent(id)}/revoke-credentials`, {});
}

/// ログイン直後の JIT 同期 (ADR 20260528 §7 / ACC-2)。`/api/admin/accounts` 配下では
/// なく自分自身の同期エンドポイントなので base を使わない。
export function syncMe(): Promise<AccountSync> {
  return api.post<AccountSync>('/api/me/sync', {});
}
